const Vue = require('vue').default
const VueAwesomeSwiper = require('vue-awesome-swiper')
const moment = require("moment")

Vue.use(VueAwesomeSwiper)

var PageFaq = {
  data: function () {
    return {
      isShow: [],
      isOpen: [],
      open:false
    }
  },
  mounted: function () {
    // alert("hoge")
  },

  methods: {
    toggle: function (data) {
      if (this.isShow.indexOf(data) >= 0) {
        this.isShow = this.isShow.filter(n => n !== data)
      }

      else {
        this.isShow.push(data)
      }
    }



    
  }
}

module.exports = PageFaq